/* eslint-disable react/jsx-curly-brace-presence, react/no-unescaped-entities */
import React from 'react';
import { Card, Grid } from '@material-ui/core';

import CompletePlan from '../../CompletePlan/CompletePlan';
import IPDocCard from '../../../IPDocCard/IPDocCard';
import PageWrapper from '../../../PageWrapper/PageWrapper';
import StickyFooter from '../../../StickyFooter/StickyFooter';
import ServiceFee from '../../ServiceFee/ServiceFee';
import ImplMethod from '../../ImplMethod/ImplMethod';
import AssetsTable from '../../AssetsTable/AssetsTable';
import TaxImplications from './TaxImplications';
import RecommendedPortfolioTable from '../../RecommendedPortfolioTable/RecommendedPortfolioTable';
import { tRoweFormatted } from '../../../../utils/Content';

const OnboardingHub = ({
    clientDetails,
    agreementsGroupByType,
    externalAccounts,
    modelAssetAllocationAssociatedFund,
    assetsAsOfDate,
    monthlyFee,
    dedicatedTotal, 
    isInternal, 
    hasAccounts, 
    urlParam,
    hasIneligibleExternalAccounts,
    hasIneligibleBrokerage
 }) =>    
        <div>
            <PageWrapper classes='top-wrapper'>
                <div className='proposalContainer' id='proposal-container'>
                    <div className='proposalHeader' id='proposal-header'>
                        <span className='blocked_data'>
                            {`${clientDetails[0].firstName}${clientDetails.length === 2 ? ` and ${clientDetails[1].firstName}` : ''}`}
                        </span>{`, let's review your Investment Proposal.`}
                    </div>
                    <div className='proposalContent' id='proposal-copy'>
                        The {tRoweFormatted} Retirement Advisory Service&trade; is intended to help you achieve your retirement and other financial goals.
                        We'll use our expertise to implement your recommended portfolio across the advisory accounts in your household and to manage them for you.
                    </div>
                    <div className='proposalContent' id='proposal-sub-copy'>
                        {`Your advisor will discuss the investment proposal information with you. You'll have the opportunity to ask questions and confirm your decisions
                    before opening your new advisory accounts. `}
                    </div>
                    <div className='proposalDetail'
                        style={{ paddingBottom: '24px' }}
                        id='proposal-detail'
                    >
                        {'After reviewing with your advisor, select "Begin Account Opening" to begin the enrollment process.'}
                    </div>
                </div>
            </PageWrapper>

            <ImplMethod />

            <Grid container>
                <Grid item xs={12} style={{ paddingTop: '64px' }}>
                    <PageWrapper style={{ paddingTop: '0px' }}>
                        <div className='proposalHeader' id='proposal-header'>
                            Current Accounts and Recommended Model
                        </div>
                    </PageWrapper>
                    <div className='compWrapper'>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Card>
                                    <div className='hub-header-container' id='hub-header-container'>
                                        <h3 className='hubProposalHeader' id='hub-prop-header'>Accounts to Fund the Service</h3>
                                        <p>
                                            The current eligible accounts you identified to be enrolled and transferred
                                            into the Service are listed below. If you have chosen to transfer any brokerage
                                            accounts into the Service, all of their underlying holdings will be included.
                                        </p>
                                        <p
                                            className='hubPropAod'
                                            id='hub-prop-as-of-date'
                                        >
                                            Proposal generated as of {assetsAsOfDate} and balances are generally as of the prior business day&apos;s close
                                        </p>
                                    </div>
                                    <AssetsTable
                                        agreementsGroupByType={agreementsGroupByType}
                                        externalAccounts={externalAccounts}
                                        clientDetails={clientDetails}
                                    />
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Card id='recc-port-card'>
                                    <div className='hub-header-container'>
                                        <div
                                            className='hubProposalHeader'
                                            id='recc-model-title'
                                        >
                                            {`Recommended ${modelAssetAllocationAssociatedFund.modelInformation.name} Portfolio`}
                                        </div>
                                        <p
                                            style={{ fontFamily: 'Nimbus Sans Reg' }}
                                            id='recc-model-copy'
                                        >
                                            {`We recommend the ${modelAssetAllocationAssociatedFund.modelInformation.name} Portfolio based on your responses to the investment 
                                        time horizon and risk tolerance questions in our Service questionnaire and other planning considerations.`}
                                        </p>
                                        <p
                                            style={{ fontFamily: 'Nimbus Sans Reg', paddingBottom: '16px' }}
                                            id='recc-model-sub-copy'
                                        >
                                            The information in the table below is based on the neutral weightings for each asset class within your Recommended Portfolio.
                                            The allocation of your assets may differ from these asset classes, funds and weights, and may change over time, as we continually assess market and economic conditions.
                                        </p>
                                    </div>
                                    <RecommendedPortfolioTable
                                        modelAssetAllocationAssociatedFund={modelAssetAllocationAssociatedFund}
                                        total={dedicatedTotal}
                                    />
                                </Card>
                            </Grid>
                        </Grid>
                    </div>

                    <PageWrapper>
                        <div className='proposalHeader coa-title' id='coa-title'>
                            Taxes and the Cost of Advice
                        </div>
                    </PageWrapper>
                    <div className='compWrapper'>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <TaxImplications agreementsGroupByType={agreementsGroupByType} assetsAsOfDate={assetsAsOfDate} />
                            </Grid>
                            <Grid item xs={12} md={6} >
                                <ServiceFee
                                    total={dedicatedTotal}
                                    fee={monthlyFee}
                                />
                                <div style={{ paddingTop: '32px' }} id='complete-plan-container'>
                                    <CompletePlan />
                                </div>
                            </Grid>
                            {isInternal && (
                                <Grid item xs={12}>
                                    <IPDocCard />
                                </Grid>
                            )}
                        </Grid>
                    </div>

                </Grid>
            </Grid>

            {hasAccounts ?
                <StickyFooter 
                    link='/personal-investing/tools/adv-nasu/legal-consent' 
                    disabled={urlParam !== undefined} 
                    hasIneligibleExternalAccounts={hasIneligibleExternalAccounts}
                    hasIneligibleBrokerage={hasIneligibleBrokerage}
                /> 
                    : null
            }
        </div>;

export default OnboardingHub;
